import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {intlShape, injectIntl} from 'react-intl';
import {fieldPropTypes} from 'redux-form';

import TextInput from './TextInput';
import Dropdown from './Dropdown';

const strings2Options = (strings, messages, prefix) => strings.map(s => messages[`${prefix}.${s}`]);

class Select extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      showAllOptions: false
    };
  }

  render() {
    const {options, intl, name} = this.props;
    let {input} = this.props;

    input = {
      ...input,
      value: input.value || '',
      onFocus: () => {
        this.setState({showAllOptions: true});
      }
    };

    const dropdownOptions = strings2Options(
      options,
      intl.messages,
      `form.select.${name || input.name}`
    )
      .filter(
        item => this.state.showAllOptions || item.toLowerCase().includes(input.value.toLowerCase())
      )
      .sort((a, b) => a.localeCompare(b));

    return (
      <Dropdown
        options={dropdownOptions}
        input={input}
        onChange={() => {
          this.setState({showAllOptions: false});
        }}
      >
        <TextInput {...this.props} input={input} rightIcon="dropdown" />
      </Dropdown>
    );
  }
}

Select.propTypes = {
  ...fieldPropTypes,
  options: PropTypes.arrayOf(PropTypes.string),
  intl: intlShape
};

export default injectIntl(Select);



// WEBPACK FOOTER //
// ./components/Form/Select.jsx